module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/preview_en-7d47da52845ccf1eb5fa4b365e39c313.png";